/**
 * MIME types that `canvas.toBlob()` can reliably encode. Notably excludes
 * `image/gif`, which `canvas.toBlob()` does not support.
 */
export const SUPPORTED_CROP_TYPES = ['image/jpeg', 'image/png', 'image/webp'] as const;

/** Fallback output type used whenever the source type is unsupported. */
export const DEFAULT_CROP_TYPE = 'image/jpeg';

/**
 * Normalises an input MIME type to one that `canvas.toBlob()` supports.
 * Any unsupported type (e.g. `image/gif`, empty string) falls back to
 * {@link DEFAULT_CROP_TYPE}.
 */
export const resolveCropMimeType = (fileType: string): string =>
  (SUPPORTED_CROP_TYPES as readonly string[]).includes(fileType) ? fileType : DEFAULT_CROP_TYPE;
